import { Delete } from "@mui/icons-material";
import {
    Box,
    Button,
    FormHelperText,
    IconButton,
    MenuItem,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from "@mui/material";
import { CustomeTextField } from "../../core/CustomeTextField";
import { IOffer } from "../../../interfaces/IOffer";
import { IOfferPosition } from "../../../interfaces/IOfferPosition";
import { IPartner } from "../../../interfaces/IPartner";
import { IUnit } from "../../../interfaces/IUnit";
import { useState } from "react";

interface IProps {
    title: string;
    selectedPositions: IOfferPosition[];
    offers: IOffer[];
    units: IUnit[];
    selectedPartners: IPartner[];
    isNoPartner?: boolean;
    setSelectedPositions: React.Dispatch<React.SetStateAction<IOfferPosition[]>>;
}

const CraftsAllocationTable = ({
    title,
    selectedPositions,
    offers,
    units,
    isNoPartner = false,
    selectedPartners,
    setSelectedPositions,
}: IProps) => {
    const [selectedPartner, setSelectedPartner] = useState<IPartner | null>(null);
    return (
        <>
            <Box sx={{ mb: 1, gap: 1 }} display="flex" alignItems="stretch" flexDirection="row">
                {isNoPartner ? (
                    <>
                        <Select
                            value={selectedPartner?.id ?? -1}
                            onChange={({ target: { value } }) =>
                                setSelectedPartner(selectedPartners.find((p) => p.id === Number(value)) || null)
                            }
                            displayEmpty
                            size="small"
                            sx={{ minWidth: "50%", mb: 1 }}
                            error={selectedPartner === null || selectedPartner.id === -1}
                        >
                            <MenuItem value={-1} disabled>
                                <i>Kein Partner ausgewählt</i>
                            </MenuItem>
                            {selectedPartners.map((p) => (
                                <MenuItem key={p.id} value={p.id}>
                                    {p.Contact_Person.Company?.company_name}
                                </MenuItem>
                            ))}
                        </Select>

                        <Button
                            variant="outlined"
                            size="small"
                            sx={{ mb: 1 }}
                            onClick={() =>
                                setSelectedPositions((prev) =>
                                    prev.map((x) =>
                                        selectedPositions.find((p) => p.id === x.id)
                                            ? { ...x, Partner: selectedPartner?.id ?? null }
                                            : x,
                                    ),
                                )
                            }
                            disabled={selectedPartner === null || selectedPartner.id === -1}
                        >
                            Alle zuweisen
                        </Button>
                    </>
                ) : (
                    <Typography>{title}</Typography>
                )}
            </Box>
            <Table size="small">
                <TableHead>
                    <TableCell sx={{ width: 200 }}>Angebot</TableCell>
                    <TableCell sx={{ width: 150 }}>Artikelnummer</TableCell>
                    <TableCell sx={{ width: 300 }}>Partner</TableCell>
                    <TableCell>Bezeichnung</TableCell>
                    <TableCell sx={{ width: 100 }}>Einheit</TableCell>
                    <TableCell sx={{ width: 200 }}>Einheiten</TableCell>
                    <TableCell sx={{ width: 200 }}>Aktionen</TableCell>
                </TableHead>
                <TableBody>
                    {selectedPositions.length === 0 ? (
                        <TableRow>
                            <TableCell colSpan={7}>
                                <i>Keine zugewiesene Positionen vorhanden.</i>
                            </TableCell>
                        </TableRow>
                    ) : (
                        selectedPositions.map((p, i) => (
                            <TableRow key={i}>
                                <TableCell>{offers.find((x) => x.id === p.Offer)?.title}</TableCell>
                                <TableCell>{p.articelNumber}</TableCell>
                                <TableCell>
                                    <Select
                                        value={p.Partner ?? -1}
                                        onChange={({ target: { value } }) =>
                                            setSelectedPositions((prev) =>
                                                prev.map((x) =>
                                                    x.id === p.id ? { ...x, Partner: Number(value) || null } : x,
                                                ),
                                            )
                                        }
                                        displayEmpty
                                        size="small"
                                        fullWidth
                                        error={p.Partner === null || p.Partner === -1}
                                    >
                                        <MenuItem value={-1} disabled>
                                            <i>Kein Partner ausgewählt</i>
                                        </MenuItem>
                                        {selectedPartners.map((p) => (
                                            <MenuItem key={p.id} value={p.id}>
                                                {p.Contact_Person.Company?.company_name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                    {(p.Partner === null || p.Partner === -1) && (
                                        <FormHelperText error>Partner muss ausgewählt werden</FormHelperText>
                                    )}
                                </TableCell>
                                <TableCell>{p.title}</TableCell>
                                <TableCell>{units.find((x) => x.id === p.Unit)?.unit}</TableCell>
                                <TableCell>{p.units}</TableCell>

                                <TableCell>
                                    {p.Partner !== null && (
                                        <IconButton
                                            size="small"
                                            onClick={() =>
                                                setSelectedPositions((prev) =>
                                                    prev.map((x) => (x.id === p.id ? { ...x, Partner: null } : x)),
                                                )
                                            }
                                        >
                                            <Delete />
                                        </IconButton>
                                    )}
                                </TableCell>
                            </TableRow>
                        ))
                    )}
                </TableBody>
            </Table>
        </>
    );
};

export default CraftsAllocationTable;
